module.exports = __webpack_public_path__ + "img/SkeletonIcon.4861b1c2.svg";